const state = {
  // 当前考试/训练数据
  currentData: null,
  // 题目列表（训练模式使用）
  questionList: [],
  // 当前步骤
  currentStep: 1,

  // 答题模式：'training' 训练模式 | 'exam' 考试模式
  answerMode: undefined,
  // 当前选择的科目类型（0：预规划，1：重规划，2：应急返航，3：训练记录）
  subjectType: undefined,
  // 考试状态：0 未报名 1 已参加 2 等待开始 3 考试中 4 已完成 5 缺考 6 AI评分中
  examStatus: undefined,
  // 打开全部考题列表
  openExamQuestions: false,
  // 开考信息
  examStartInfo: null,
  // 考试内容
  examInfo: null,
  // 考试id
  examId: '',
  // 考试学生id
  examStudentId: '',
  // 用户回答记录id	
  answerId: '',
  // UAV姿态
  uavAttitude: null,
  // 教练列表
  coachList: [],
  // 用户选择的教练
  selectedCoach: null,
  // 当前训练的科目id
  subjectId: '',
  // 归航点
  returnPoint: null,

  // 教育版组件显示隐藏控制
  componentVisibility: {
    // 训练科目列表
    examSubject: false,
    // 分校和教员选择布局头部
    layoutHeader: false,
    // 考试列表
    examList: false,
    // 版本切换组件
    versionSwitching: false,
    // 预规划题库
    questionBank: false,
    // 预规划训练/考试具体题目
    prePlanningExamItem: false,
    // 考题列表
    examAllList: false,
    // 开考中考试题目
    examingSubject: false,
    // 考题名字和科目名
    examTitle: false,
    // 应急返航
    takeHome: false,
    // 考试状态显示
    examStatus: false,
  }
}

const mutations = {
  // 设置归航点
  SET_RETURN_POINT(state, returnPoint) {
    state.returnPoint = returnPoint
  },
  // 设置科目类型
  SET_SUBJECT_TYPE(state, subjectType) {
    state.subjectType = subjectType
  },
// 设置用户回答记录id
  SET_ANSWER_ID(state, answerId) {
    state.answerId = answerId
  },
  // 设置UAV姿态
  SET_UAV_ATTITUDE(state, uavAttitude) {
    state.uavAttitude = uavAttitude
  },

  // 设置教练列表
  SET_COACH_LIST(state, coachList) {
    state.coachList = coachList
  },
  // 设置用户选择的教练
  SET_SELECTED_COACH(state, selectedCoach) {
    state.selectedCoach = selectedCoach
  },
  // 设置当前训练的科目id
  SET_SUBJECT_ID(state, subjectId) {
    state.subjectId = subjectId
  },

  // 设置组件显示隐藏状态
  SET_COMPONENT_VISIBILITY(state, { component, visible }) {
    if (state.componentVisibility.hasOwnProperty(component)) {
      state.componentVisibility[component] = visible
    }
  },

  // 批量设置组件显示隐藏状态
  SET_MULTIPLE_COMPONENT_VISIBILITY(state, visibilityMap) {
    Object.keys(visibilityMap).forEach(component => {
      if (state.componentVisibility.hasOwnProperty(component)) {
        state.componentVisibility[component] = visibilityMap[component]
      }
    })
  },

  // 重置所有组件显示状态
  RESET_COMPONENT_VISIBILITY(state) {
    Object.keys(state.componentVisibility).forEach(component => {
      state.componentVisibility[component] = false
    })
  },

  setState(state, payload) {
    state[payload.key] = payload.value
  },

  // 设置当前数据
  SET_CURRENT_DATA(state, data) {
    state.currentData = data
  },

  // 设置题目列表
  SET_QUESTION_LIST(state, list) {
    state.questionList = list
  },

  // 设置当前步骤
  SET_CURRENT_STEP(state, step) {
    state.currentStep = step
  },

  // 设置状态
  SET_STATUS(state, examStatus) {
    state.examStatus = examStatus
  },

  // 设置开始时间
  SET_START_TIME(state, time) {
    state.startTime = time
  },

  // 设置结束时间
  SET_END_TIME(state, time) {
    state.endTime = time
  },

  // 设置计时器
  SET_TIMER(state, timer) {
    state.timer = timer
  },

  // 设置时间限制
  SET_TIME_LIMIT(state, timeLimit) {
    state.timeLimit = timeLimit
  },

  // 增加计时器（倒计时：减少剩余时间）
  INCREMENT_TIMER(state) {
    if (state.timer > 0) {
      state.timer--
      // console.log('倒计时递减，剩余时间:', state.timer, '秒')
    } else {
      // console.log('时间到！倒计时结束')
    }
  },

  // 重置计时器（设置为时间限制值）
  RESET_TIMER(state) {
    state.timer = state.timeLimit
  },

  // 设置答题模式
  SET_ANSWER_MODE(state, answerMode) {
    state.answerMode = answerMode
  },

  // 重置所有状态
  RESET_STATE(state) {
    state.answerMode = undefined
    state.subjectType = undefined
    state.examStatus = undefined
    state.openExamQuestions = false
    state.examStartInfo = null
    state.examInfo = null
    state.examId = ''
    state.examStudentId = ''
    state.answerId = ''
    state.uavAttitude = null
    // 重置组件显示状态
    Object.keys(state.componentVisibility).forEach(component => {
      state.componentVisibility[component] = false
    })
  },

  // 设置开考信息
  SET_EXAM_START_INFO(state, info) {
    state.examStartInfo = info
  },
  // 设置考试内容
  SET_EXAM_INFO(state, info) {
    state.examInfo = info
  },
  // 设置考试id
  SET_EXAM_ID(state, info) {
    state.examId = info.examId;
    state.examStudentId = info.examStudentId;
  },

}

const actions = {
  // 开始考试/训练
  startSession({ commit, state }, { answerMode, data, questionList, timeLimit = 0 }) {
    commit('SET_ANSWER_MODE', answerMode)
    commit('SET_STATUS', 'in-progress')
    commit('SET_START_TIME', Date.now())
    commit('SET_TIME_LIMIT', timeLimit)
    commit('RESET_TIMER')
    commit('SET_CURRENT_STEP', 1)

    if (answerMode === 'exam') {
      commit('SET_CURRENT_DATA', data)
    } else {
      commit('SET_QUESTION_LIST', questionList)
      if (questionList && questionList.length > 0) {
        commit('SET_CURRENT_DATA', questionList[0])
      }
    }
  },

  // 切换步骤（训练模式）
  changeStep({ commit, state }, step) {
    if (state.answerMode === 'training' && state.questionList && state.questionList[step - 1]) {
      commit('SET_CURRENT_STEP', step)
      commit('SET_CURRENT_DATA', state.questionList[step - 1])
    }
  },

  // 提交答案
  submitAnswer({ commit, state }, answerData) {
    commit('SET_STATUS', 'completed')
    commit('SET_END_TIME', Date.now())

    // 这里可以添加提交到服务器的逻辑
    return {
      mode: state.answerMode,
      step: state.currentStep,
      startTime: state.startTime,
      endTime: Date.now(),
      timeSpent: state.timer,
      answerData
    }
  },

  // 重新开始
  restart({ commit }) {
    commit('RESET_STATE')
  },

  // 更新计时器
  updateTimer({ commit }, timer) {
    commit('SET_TIMER', timer)
  },

  // 增加计时器（倒计时）
  incrementTimer({ commit, state, dispatch }) {
    commit('INCREMENT_TIMER')

    // 如果时间到了，自动提交
    if (state.timer <= 0) {
      dispatch('timeUp')
    }
  },

  // 时间到达处理
  timeUp({ commit, state }) {
    commit('SET_STATUS', 'completed')
    commit('SET_END_TIME', Date.now())

    // 触发时间到达事件
    return {
      type: 'timeout',
      mode: state.answerMode,
      step: state.currentStep,
      startTime: state.startTime,
      endTime: Date.now(),
      timeLimit: state.timeLimit
    }
  }
}

const getters = {
  // 是否为训练模式
  isTrainingMode: state => state.answerMode === 'training',

  // 是否为考试模式
  isExamMode: state => state.answerMode === 'exam',

  // 获取组件显示状态
  getComponentVisibility: (state) => (component) => {
    return state.componentVisibility[component] || false
  },

  // 获取所有组件显示状态
  getAllComponentVisibility: state => state.componentVisibility,

  // 是否进行中
  isInProgress: state => state.examStatus === 'in-progress',

  // 是否已完成
  isCompleted: state => state.examStatus === 'completed',

  // 格式化时间（倒计时）
  formattedTime: state => {
    const remainingTime = state.timer // 现在timer存储的是剩余时间
    const hours = Math.floor(remainingTime / 3600)
    const minutes = Math.floor((remainingTime % 3600) / 60)
    const seconds = remainingTime % 60
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  },

  // 当前题目的预规划信息
  currentPrePlannedInfo: state => {
    return state.currentData?.prePlannedInfo || {}
  },

  // 题目总数
  totalSteps: state => {
    return state.answerMode === 'training' ? state.questionList.length : 1
  },

  // 已用时长（毫秒）
  timeSpent: state => {
    if (state.startTime) {
      const endTime = state.endTime || Date.now()
      return endTime - state.startTime
    }
    return 0
  },

  // 剩余时间（秒）
  remainingTime: state => state.timer,

  // 是否时间紧急（剩余时间少于30秒）
  isTimeUrgent: state => state.timer > 0 && state.timer <= 30,

  // 时间进度百分比
  timeProgress: state => {
    if (state.timeLimit > 0) {
      return ((state.timeLimit - state.timer) / state.timeLimit) * 100
    }
    return 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}